"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMatrixGenerationOptions = exports.deleteExclusionZone = exports.addExclusionZone = void 0;
const uuid_1 = require("@lukeed/uuid");
const getActiveWorkspace_1 = require("../utilities/getActiveWorkspace");
function addExclusionZone(draft, action) {
    const { zone, range, nucleus } = action.payload;
    const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
    const panels = currentWorkspacePreferences.formatting.panels;
    const exclusionZone = {
        id: (0, uuid_1.v4)(),
        ...zone,
    };
    if (!panels.matrixGeneration?.[nucleus]) {
        const options = {
            exclusionsZones: [exclusionZone],
            filters: [],
            range,
            numberOfPoints: 1024,
        };
        panels.matrixGeneration = {
            ...panels.matrixGeneration,
            [nucleus]: options,
        };
    }
    else {
        panels.matrixGeneration[nucleus].exclusionsZones.push(exclusionZone);
    }
}
exports.addExclusionZone = addExclusionZone;
function deleteExclusionZone(draft, action) {
    const { zone, nucleus } = action.payload;
    const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
    const panels = currentWorkspacePreferences.formatting.panels;
    if (panels.matrixGeneration?.[nucleus]) {
        const options = panels.matrixGeneration[nucleus];
        options.exclusionsZones = options.exclusionsZones.filter((_zone) => _zone.id !== zone.id);
    }
}
exports.deleteExclusionZone = deleteExclusionZone;
function setMatrixGenerationOptions(draft, action) {
    const { options, nucleus } = action.payload;
    const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
    const panels = currentWorkspacePreferences.formatting.panels;
    panels.matrixGeneration = { ...panels.matrixGeneration, [nucleus]: options };
}
exports.setMatrixGenerationOptions = setMatrixGenerationOptions;
